import { project } from './project/project'
import { upload } from './upload/upload'
import { auth } from './auth/auth'
import { staff } from './staff/staff'
import { memberRequest } from './memberRequest/memberRequest'
import { corp } from './corp/corp'
import { notification } from './notification/notification'
import { pricing } from './pricing/pricing'
import { expert } from './expert/expert'
import { statistic } from './statistic/statistic'
import { compare } from './compare/compare'
import { knowledge } from './knowledge/knowledge'
import { tracking } from './tracking/tracking'
export const api = {
  project,
  upload,
  auth,
  staff,
  memberRequest,
  corp,
  notification,
  pricing,
  expert,
  statistic,
  compare,
  knowledge,
  tracking,
}
